import { useState, useEffect } from "preact/compat";
import DOMPurify from "dompurify";
import useLocalStorageState from "use-local-storage-state";
import { getStateName } from "@/Utils";
import { surfsideSetLocation } from "@/shared/surfside-analytics";
import UPDATE_CHECKOUT_MUTATION from '@/mutations/updateCheckout';

function useAgeGate() {
	const [ageGatePassed, setAgeGatePassed] = useLocalStorageState("cp_age_gate_passed", false);
	const [orderType, setOrderType] = useLocalStorageState('cp_fulfillment_type');
	const [retailers, setRetailers] = useState(dutchie.retailers);
	const [dutchieRetailer, setDutchieRetailer] = useLocalStorageState("dutchie_retailer", null);
	const [fulfillment, setFulfillment] = useLocalStorageState("cp_fulfillment_type", null);
	const [step, setStep] = useState(1);
	const [stepState, setStepState] = useState("");
	const [showWarning, setShowWarning] = useState(false);
	const [cpBotList, setCpBotList] = useState([]);

	let allStates = new Set();
	retailers.map((loc) => {
		if ( !loc.state || loc.hidden === true ) {
			return;
		}
		allStates.add(getStateName(loc.state));
	});
	allStates = Array.from(allStates);
	const filteredLocations = retailers.filter(
		(location) => getStateName(location.state) === stepState
	);

	const yesText = window.ageGate.yesText;
	const noText = window.ageGate.noText;
	const content = window.ageGate.content;
	const sanitizedContent = DOMPurify.sanitize(content);
	const cpAgeGate = document.getElementById("cp-age-gate");
	const [userHomeStore, setUserHomeStore] = useLocalStorageState('dutchie_retailer', null);
	const retailerId = typeof dutchie_retailer !== 'undefined' ? dutchie_retailer?.id : null;

	useEffect(() => {
		import('@/BotList').then((module) => {
			setCpBotList(module.cpBotList);
		});
	}, []);

	let cpIsABot = false;
	cpBotList.forEach(entry => {
		if (RegExp(entry.pattern).test(window.navigator.userAgent) ) {
			cpIsABot = true; // bot detected
			return;
		}
	});

	if (cpIsABot) {
		return null;
	}

	const closeAgeGate = () => {
		if ( !cpAgeGate.classList.contains("is-open") ) {
			// are we already on a shopping page?
			const currentPath = window.location.pathname;
			const pathsToCheck = [ '/location/', '/shop/', '/specials/', '/product/', '/blog/'];

			if (pathsToCheck.some(path => currentPath.includes(path))) {
				return;
			}

			window.location.href = '/shop/'; // Redirect to shop page if age gate is not present
			return;
		}
		setAgeGatePassed(true);
		cpAgeGate.classList.remove("is-open");
		document.body.style.overflow = "visible";
	}

	const setDutchieRetailerAndFulfillment = (retailer, type) => {
		setDutchieRetailer(retailer);
		setFulfillment(type);

		surfsideSetLocation({
			id: retailer.id,
			country_code: 'US'
		});

		closeAgeGate();
	}

	if (cpAgeGate && ageGatePassed !== true) {
		cpAgeGate.classList.add("is-open");
		document.body.style.overflow = "hidden";
	}

	return {
		ageGatePassed, 
		setAgeGatePassed, 
		step, 
		setStep, 
		stepState, 
		setStepState, 
		showWarning, 
		setShowWarning, 
		yesText, 
		noText, 
		content, 
		sanitizedContent,
		allStates,
		filteredLocations,
		closeAgeGate,
		setDutchieRetailerAndFulfillment
	}
}
export default useAgeGate;